import { jsxs, jsx } from 'react/jsx-runtime';

var InField = function InField(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === undefined ? '40' : _ref$size;
  return jsxs("svg", {
    width: size,
    height: size,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "cogs-v10 cogs-graphic cogs-graphic--infield",
    children: [jsx("title", {
      children: "InField product logo"
    }), jsx("path", {
      d: "M38.75 25.024L14.976 38.7499L1.25008 14.9759L25.0241 1.24999L38.75 25.024Z",
      fill: "url(#paint0_linear_2861_43309)"
    }), jsx("path", {
      d: "M38.75 25.024L14.976 38.7499L1.25008 14.9759L25.0241 1.24999L38.75 25.024Z",
      fill: "url(#paint1_linear_2861_43309)"
    }), jsx("rect", {
      x: "31.6071",
      y: "23.11",
      width: "16.994",
      height: "16.994",
      rx: "2",
      transform: "rotate(150 31.6071 23.11)",
      fill: "#ABC9FF"
    }), jsx("rect", {
      x: "31.6071",
      y: "23.11",
      width: "16.994",
      height: "16.994",
      rx: "2",
      transform: "rotate(150 31.6071 23.11)",
      fill: "url(#paint2_radial_2861_43309)"
    }), jsx("path", {
      d: "M20 20L38.7499 25.024L14.9759 38.7499L20 20Z",
      fill: "url(#paint3_linear_2861_43309)",
      fillOpacity: "0.25"
    }), jsx("path", {
      d: "M20 20L38.7499 25.024L14.9759 38.7499L20 20Z",
      fill: "url(#paint4_linear_2861_43309)",
      fillOpacity: "0.25"
    }), jsx("path", {
      d: "M20 20L1.25 14.9759L25.024 1.25002L20 20Z",
      fill: "url(#paint5_linear_2861_43309)",
      fillOpacity: "0.55"
    }), jsx("path", {
      d: "M20 20L1.25 14.9759L25.024 1.25002L20 20Z",
      fill: "url(#paint6_linear_2861_43309)",
      fillOpacity: "0.55"
    }), jsx("path", {
      d: "M20 20L14.9759 38.7499L1.25003 14.9759L20 20Z",
      fill: "url(#paint7_linear_2861_43309)",
      fillOpacity: "0.15"
    }), jsx("path", {
      d: "M20 20L14.9759 38.7499L1.25003 14.9759L20 20Z",
      fill: "url(#paint8_linear_2861_43309)",
      fillOpacity: "0.15"
    }), jsx("path", {
      d: "M20 20L25.024 1.25001L38.7499 25.024L20 20Z",
      fill: "url(#paint9_linear_2861_43309)",
      fillOpacity: "0.35"
    }), jsx("path", {
      d: "M20 20L25.024 1.25001L38.7499 25.024L20 20Z",
      fill: "url(#paint10_linear_2861_43309)",
      fillOpacity: "0.35"
    }), jsxs("defs", {
      children: [jsxs("linearGradient", {
        id: "paint0_linear_2861_43309",
        x1: "0.567673",
        y1: "14.9971",
        x2: "39.3953",
        y2: "25.4009",
        gradientUnits: "userSpaceOnUse",
        children: [jsx("stop", {
          stopColor: "#4967FB"
        }), jsx("stop", {
          offset: "1",
          stopColor: "#23D8ED"
        })]
      }), jsxs("linearGradient", {
        id: "paint1_linear_2861_43309",
        x1: "15.44",
        y1: "37.7249",
        x2: "25.245",
        y2: "1.13224",
        gradientUnits: "userSpaceOnUse",
        children: [jsx("stop", {
          stopColor: "white",
          stopOpacity: "0"
        }), jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0.6"
        })]
      }), jsxs("radialGradient", {
        id: "paint2_radial_2861_43309",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(40.1041 31.6071) rotate(133.874) scale(7.91449)",
        children: [jsx("stop", {
          stopColor: "white",
          stopOpacity: "0.8"
        }), jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      }), jsxs("linearGradient", {
        id: "paint3_linear_2861_43309",
        x1: "20",
        y1: "20",
        x2: "26.8629",
        y2: "31.887",
        gradientUnits: "userSpaceOnUse",
        children: [jsx("stop", {
          stopColor: "white"
        }), jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      }), jsxs("linearGradient", {
        id: "paint4_linear_2861_43309",
        x1: "20",
        y1: "20",
        x2: "26.8629",
        y2: "31.887",
        gradientUnits: "userSpaceOnUse",
        children: [jsx("stop", {
          stopColor: "white"
        }), jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      }), jsxs("linearGradient", {
        id: "paint5_linear_2861_43309",
        x1: "20.1634",
        y1: "20.283",
        x2: "13.3004",
        y2: "8.39601",
        gradientUnits: "userSpaceOnUse",
        children: [jsx("stop", {
          stopColor: "white"
        }), jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      }), jsxs("linearGradient", {
        id: "paint6_linear_2861_43309",
        x1: "20.1634",
        y1: "20.283",
        x2: "13.3004",
        y2: "8.39601",
        gradientUnits: "userSpaceOnUse",
        children: [jsx("stop", {
          stopColor: "white"
        }), jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      }), jsxs("linearGradient", {
        id: "paint7_linear_2861_43309",
        x1: "20",
        y1: "20",
        x2: "8.11299",
        y2: "26.8629",
        gradientUnits: "userSpaceOnUse",
        children: [jsx("stop", {
          stopColor: "white"
        }), jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      }), jsxs("linearGradient", {
        id: "paint8_linear_2861_43309",
        x1: "20",
        y1: "20",
        x2: "8.11299",
        y2: "26.8629",
        gradientUnits: "userSpaceOnUse",
        children: [jsx("stop", {
          stopColor: "white"
        }), jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      }), jsxs("linearGradient", {
        id: "paint9_linear_2861_43309",
        x1: "19.7169",
        y1: "20.1634",
        x2: "31.6039",
        y2: "13.3004",
        gradientUnits: "userSpaceOnUse",
        children: [jsx("stop", {
          stopColor: "white"
        }), jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      }), jsxs("linearGradient", {
        id: "paint10_linear_2861_43309",
        x1: "19.7169",
        y1: "20.1634",
        x2: "31.6039",
        y2: "13.3004",
        gradientUnits: "userSpaceOnUse",
        children: [jsx("stop", {
          stopColor: "white"
        }), jsx("stop", {
          offset: "1",
          stopColor: "white",
          stopOpacity: "0"
        })]
      })]
    })]
  });
};

export { InField };
